<template>
    <div id="bene-aud-bt-state-container">
        <f7-list form class="form-group" v-if="showFormInput.kaasiDetails.state">
            <f7-list-input
                input-id     ="state"
                id           ="stateInput"
                name         ="state"
                class        ="clickable-row use-chevron"

                :label       ="$t('beneficiary-state')"
                :placeholder ="$t('beneficiary-select-state')"
                :value       ="province"

                autocomplete ="off"
                outline
                floating-label
            >
                <f7-link popover-open=".popover-dropdown-aud-province" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>

            <f7-popover id="dropdownState" class="popover-dropdown-aud-province dropdown-default dropdown beneficiary" :backdrop="true">
                <f7-list>
                    <f7-list-item popover-close link="#"
                    v-for="item in provinceList"
                    :key="item.key"
                    selected=""
                    @click="showPreloader();setPostcode('');setCity({id: 0, name: ''});setInputState('kaasiPostcode', false);changeProvince(item.key);">
                        {{item.value}}
                    </f7-list-item>
                </f7-list>
            </f7-popover>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
            this.init();
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'province',
                'provinceId',
                'provinceList',

            ])
        },
        methods: {
            ...mapActions('beneficiary', [
                'setProvince',
                'setPostcode',
                'setCity',
            ]),

            async init(){
                //await this.renderDropdown();

                // STATE
                const self    = this;
                const popover = ".beneficiary.popover-dropdown-aud-province";
                const popoverInner = ".beneficiary.popover-dropdown-aud-province .popover-inner";
                const popoverId = "dropdownState";
                const inputId = "state";
                const inputListId = "#stateInput";
                await self.setDropdownDirection(popover, popoverInner, popoverId, inputId, inputListId)

            },

            renderDropdown(){
                const self = this;

                self.Dom7('.beneficiary.popover-dropdown-aud-province').on('popover:open', function () {
                    self.$$(".popover-dropdown-aud-province").css({
                        'visibility' : 'hidden',
                    });
                });

                self.Dom7('.beneficiary.popover-dropdown-aud-province').on('popover:opened', function () {
                    var thepopover = self.Dom7('.beneficiary.popover-dropdown-aud-province');
                    const classes = thepopover[0].firstChild.classList;
                    const popoverDirection = classes[1];
                    console.log("BANK NAME direction: "+popoverDirection)

                    const parentPosBottom = document.getElementById('state').getBoundingClientRect().bottom;
                    const parentPosLeft = document.getElementById('state').getBoundingClientRect().left;

                    self.$$("#stateInput").removeClass("dropdown-list").addClass("dropdown-list");

                    if(popoverDirection == "on-top" || popoverDirection == "on-left" || popoverDirection == "on-right"){
                        self.$$(".beneficiary.popover-dropdown-aud-province").css({
                            'visibility' : 'visible',
                            'top' : (parentPosBottom) + 'px',
                            'margin-left' : (parentPosLeft) + 'px'
                        });
                    } else if(popoverDirection == "on-bottom"){
                        self.$$(".beneficiary.popover-dropdown-aud-province").css({
                            'visibility' : 'visible',
                            'margin-top' : (8) + 'px',
                            'margin-left' : (parentPosLeft) + 'px'
                        });
                    }
                });

                self.Dom7('.beneficiary.popover-dropdown-aud-province').on('popover:closed', function () {
                    self.$$("#stateInput").removeClass("dropdown-list");
                });
            },

            changeProvince(id){
                this.$emit("changeProvince", id);
            },

            validateInput(inputEl){
                this.$emit("validateInput", inputEl);
            },

            setInput(inputEl){
                this.$emit("setInput", inputEl);
            }
        }
    }
</script>